import { axiosInstance, axiosCompanyPortalInstance, axiosClientPortalInstance } from "./";

const instanceFor = (portalVariant) => {
  if (portalVariant === "company-portal") return axiosCompanyPortalInstance;
  if (portalVariant === "client-portal") return axiosClientPortalInstance;
  return axiosInstance;
};

export const getEventHeatmap = (data) => {
  return instanceFor(data?.portalVariant).get(`/events/${data?.event_id}/heatmaps`, {
    params: data?.zone_id ? { zone_id: data.zone_id } : {},
  });
};
